import { off, onValue, remove, set } from "firebase/database";
import firebaseKit from "./firebase/firebaseKit";
// import firebase from "firebase/app";
// import "firebase/database";

// const db = firebase.database();
import { getRef, refs } from "./firebase/firebaseRefKit";

export default class SpeedMeetingKit {
  static listenToRedirectUrl({
    eventSlug,
    pageSlug,
    eventUserId,
    onChange = () => {},
  }) {
    // const ref = db.ref(
    //   `speed-date/${eventSlug}/${pageSlug}/eu-${eventUserId}/redirect_url`
    // );

    const ref = getRef(
      refs["speed-meeting"].$eventSlug.$pageSlug.$eventUserId.redirect_url,
      {
        eventSlug,
        pageSlug,
        eventUserId: `eu-${eventUserId}`,
      }
    );
    if (ref) {
      onValue(ref, (snapshot) => onChange(snapshot));
      return () => off(ref);
    }
  }

  static setUserData({ eventSlug, pageSlug, eventUserId }) {
    const ref = getRef(refs["speed-meeting"].$eventSlug.$pageSlug.$eventUserId, {
      eventSlug,
      pageSlug,
      eventUserId: `eu-${eventUserId}`,
    });
    if (ref) {
      set(ref, {
        is_in_pre_meeting_room: firebaseKit.util.getServerTimestamp(),
        is_in_pre_meeting_room_readable: new Date().toUTCString(),
        redirect_url: false,
        event_user_id: eventUserId,
      });
  
      return () =>
        remove(ref).catch((err) => {
          console.log(err);
        });
    }
  }
}
